import React, { useEffect, useState } from "react";
import { CBadge } from '@coreui/react'
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
    fetchUserTable,
} from "../../features/commonSlice/commonSlice";
import { Button, OverlayTrigger, Tooltip } from "react-bootstrap";

const UserDataList = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {
        usersTableData,
        status: commonStatus,
    } = useSelector((state) => state.influencer);


    const [usersTableList, setUsersTableList] = useState([]);

    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);

    useEffect(() => {
        dispatch(fetchUserTable());
    }, [dispatch]);


    useEffect(() => {
        if (commonStatus === "succeeded") {
            setUsersTableList(usersTableData || []);
        }
    }, [commonStatus, usersTableData]);


    const totalRecords = usersTableList?.length || 0;

    const totalPages =
        recordsPerPage === 2000 ? 1 : Math.ceil(totalRecords / recordsPerPage);

    const indexOfLast =
        recordsPerPage === 2000 ? totalRecords : currentPage * recordsPerPage;

    const indexOfFirst =
        recordsPerPage === 2000 ? 0 : indexOfLast - recordsPerPage;

    const currentData =
        recordsPerPage === 2000
            ? usersTableList
            : usersTableList.slice(indexOfFirst, indexOfLast);
    const getPaginationItems = (current, total) => {
        const pages = [];

        pages.push(1);

        if (current > 3) pages.push("...");

        for (
            let i = Math.max(2, current - 1);
            i <= Math.min(total - 1, current + 1);
            i++
        ) {
            pages.push(i);
        }

        if (current < total - 2) pages.push("...");

        if (total > 1) pages.push(total);

        return pages;
    };

    const handleAddUser = (rowData) => {
        navigate(`/create-new-user`);
    };

    const handleEdit = (rowData) => {
        navigate(`/update-user-details/${rowData?.id}`, { state: rowData });
    };
    const handleResetPassword = (rowData) => {
        navigate(`/reset-user-password/${rowData?.id}`, { state: rowData });
    };
    const getStatusBadge = (status) => {
        switch (status) {
            case 1:
            return <CBadge color="success">Active</CBadge>

            case 0:
            return <CBadge color="warning">Pending</CBadge>

            case 3:
            return <CBadge color="danger">Deleted</CBadge>

            case 4:
            return <CBadge color="secondary">Inactive</CBadge>

            default:
            return <CBadge color="light">-</CBadge>
        }
    }
    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">User List </h4>
                    </div>
                </div>
            </div>
            <div className="row mt-4">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header">
                            <div className="card-header d-flex justify-content-between align-items-center">
                                <h5 className="mb-0">User List </h5>

                                <Button
                                    className="btn btn-sm btn-success add-btn"
                                    onClick={handleAddUser}
                                >
                                    <i className="ri-add-line align-bottom me-1"></i> Register New User
                                </Button>
                            </div>
                            <div className="row mb-2">
                                <div className="col-md-2">
                                    <label className="small">Select Records</label>
                                    <Select
                                        options={[
                                            { value: 10, label: "10" },
                                            { value: 25, label: "25" },
                                            { value: 50, label: "50" },
                                            { value: 100, label: "100" },
                                            { value: 2000, label: "All" },
                                        ]}
                                        defaultValue={{ value: 10, label: "10" }}
                                        onChange={(e) => {
                                            setRecordsPerPage(e.value);
                                            setCurrentPage(1);
                                        }}
                                    />
                                </div>
                                {/* <div className="col-sm-auto ms-auto">
                                    <div className="hstack gap-2">
                                        <Button
                                            className="btn btn-sm btn-success add-btn"
                                            onClick={handleAddUser}
                                        >
                                            <i className="ri-add-line align-bottom me-1"></i> Register New User
                                        </Button>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        <div className="card-body">
                            <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Mobile No</th>
                                            <th>Role</th>
                                            <th>Manager</th>
                                            <th>Credits</th>
                                            <th>Status</th>
                                            <th>Action</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Array.isArray(usersTableList) &&
                                            usersTableList.length > 0 ? (
                                            currentData.map((user, index) => (
                                                <tr key={user.id || index}>
                                                    <td>
                                                        {recordsPerPage === 2000
                                                            ? index + 1
                                                            : (currentPage - 1) * recordsPerPage + index + 1}
                                                    </td>
                                                    <td>{user.name}</td>
                                                    <td>{user.email}</td>
                                                    <td>{user.mobile_no}</td>
                                                    <td>{user.role_name || "-"}</td>
                                                    <td>{user.MgrName || "-"}</td>
                                                    <td>
                                                        {Number(user.credit_out) > 0 ||
                                                            Number(user.credit_in) > 0
                                                            ? `${user.credit_out || 0} / ${user.credit_in || 0}`
                                                            : "-"}
                                                    </td>
                                                    <td>{getStatusBadge(user.status)}</td>
                                                    <td>
                                                        <div className="d-flex gap-2">
                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip id="tooltip-top">
                                                                        Edit User Details
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-primary btn-sm"
                                                                    onClick={() => handleEdit(user)}
                                                                >
                                                                    <i className="ri-edit-fill align-bottom"></i>
                                                                </button>
                                                            </OverlayTrigger>

                                                            <OverlayTrigger
                                                                placement="top"
                                                                overlay={
                                                                    <Tooltip id="tooltip-top-reset">
                                                                        Reset User Password
                                                                    </Tooltip>
                                                                }
                                                            >
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-warning btn-sm"
                                                                    onClick={() => handleResetPassword(user)}
                                                                >
                                                                    <i className="ri-lock-password-fill align-bottom"></i>
                                                                </button>
                                                            </OverlayTrigger>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center">
                                                    No users found
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div className="row mt-2 px-2">
                            <div className="col-md-6">
                                Showing {totalRecords === 0 ? 0 : indexOfFirst + 1} to{" "}
                                {Math.min(indexOfLast, totalRecords)} of {totalRecords}
                            </div>

                            <div className="col-md-6">
                                <ul className="pagination justify-content-end">
                                    {/* PREV */}
                                    <li
                                        className={`page-item ${currentPage === 1 && "disabled"}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() =>
                                                setCurrentPage((prev) => Math.max(prev - 1, 1))
                                            }
                                        >
                                            Prev
                                        </button>
                                    </li>

                                    {/* PAGE NUMBERS */}
                                    {getPaginationItems(currentPage, totalPages).map((page, i) =>
                                        page === "..." ? (
                                            <li key={i} className="page-item disabled">
                                                <span className="page-link">...</span>
                                            </li>
                                        ) : (
                                            <li
                                                key={i}
                                                className={`page-item ${page === currentPage ? "active" : ""}`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() => setCurrentPage(page)}
                                                >
                                                    {page}
                                                </button>
                                            </li>
                                        ),
                                    )}

                                    {/* NEXT */}
                                    <li
                                        className={`page-item ${currentPage === totalPages && "disabled"
                                            }`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() =>
                                                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
                                            }
                                        >
                                            Next
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserDataList
